import Draggable from "../../plugins/draggable";

export default class SuperWheel {
    constructor(api) {
        this.api = api;

        this.instanceAvailable = false;
        this.inited = false;
        this.initialLoadReceived = false;
        this.superwheelActive = false;
        this._splashDisplayed = false;
        this._helpOpen = false;
        this._soundEnabled = false;
        
        //PERCENTAGE or ABSOLUTE
        this.sideBetCalculationType = 'PERCENTAGE';

        //amount in case sideBetCalculationType = 'ABSOLUTE' 
        // percentage of in game bet in case sideBetCalculationType = 'PERCENTAGE' 
        this.sideBetAmount = 100;

        //teaser should be displayed every 5 rounds when Superwheel is not active
        this.roundsNotActive = 0;

        //teaser should be displayed every 3% of rounds not won when Superwheel is active
        this.roundsNotWon = 0;

        //array to hold open raffles
        this.raffles = [];
        //'https://sws.st01-lc-stakelogic.com/raffle/c215ec01-442d-4b81-8e5f-40b346390a9f'
        this.promotedFeature = false;
        this.superWheelBet = 0;
        this.hitRate = null;
        this.totalBet = 0;
        this.totalBetContainer = null;
        this.gamePlatformId = null;
        this.platform = 'DESKTOP';
    }

    addRaffles(raffles) {
        this.raffles = this.raffles.concat(raffles);
    }

    startNextRound() {
        if(this.raffles && this.raffles.length>0) {
            this.api.gb.emitters.emit.game.soundOff();
            this.api.gb.emitters.emit.game.pauseGame();
            
            window.SLSW.startSuperWheelRound({
                soundEnabled: this._soundEnabled,
                studioLink: this.raffles[0],
                balance: (this.api.gb.balance)?this.api.gb.balance/100:0,
                betAmount: (this.superWheelBet)?(this.superWheelBet/100).toFixed(2):0
            });
            this.raffles.shift();
        }
    }

    async init(instance) {
        if (instance.data && instance.data.cdn && instance.data.cdn.js) {
            await this.api.util.loadJS(instance.data.cdn.js);
            await this.api.util.loadGameBridgeCSS();
            this.instanceAvailable = true;

            this.api.comm.registerInstance({
                "module": "stakelogic_superwheel",
                "instance": "superwheel",
                "data": {}
            });
        }
    }

    initWheel () {
        if( !this.instanceAvailable || this.inited || !this.initialLoadReceived) {
            return;
        }
        this.inited = true;

        let container = document.createElement("div");
        container.id = "superwheel-wrapper";
        container.className = "active superwheel-active";
        document.body.append(container);


        let rulesContainer = document.createElement("div");
        rulesContainer.className = "landscape superwheel-help";
        rulesContainer.id = "superwheel-help"

        container = document.createElement("div");
        container.id = "sw-ui-rules";
        container.className = "gb"
        container.style = "user-select: auto; width: 100%; height: 100%; background: rgba(0,0,0,0.8); color: white; font-family: Arial, sans-serif; position: absolute; left: 0px; top: 0; bottom: 0; right: 0; z-index: auto; display: none;";

        container.innerHTML ='<div style = "background-color: black; opacity:0.8;"></div><div id="sw-ui-rules-title" style="padding-top: 1.4em; height:10vh; width: 100%">SUPER WHEEL™</div><div id="sw-ui-rules-titlebar"></div><div id="sw-ui-rules-cont" class="gb landscape" style="height:80vh; padding-top: 0.6em"></div><div id="sw-ui-rules-close" style="display: block;"></div>';
        
        rulesContainer.appendChild(container);
        document.body.append(rulesContainer);

        window.addEventListener("resize", () => {
            var el = document.getElementById('superwheel-help');
            el.style = 'font-size: ' + el.offsetWidth*0.0145 + 'px';
        });

        // sw-teaser-container
        container = document.createElement("div");
        container.id = "sw-teaser-container";
        container.className = "sw-teaser-container"
        // container.style = "top: 00px; left: 0px; position:absolute; z-index:auto; user-select: none; font-size: 14px";

        document.body.append(container);

        container = document.createElement("div");
        container.id = "superwheel-button";
        container.className = "active";
        container.innerHTML = '<div id="sw-ui-opts" class="sw-ui-icon superwheel-opts"></div>'

        document.body.append(container);

        document.getElementById('sw-ui-opts').onclick = () => {
            this.toggleHelp();
        };

        try {
            var lang;
            switch (this.api.gb.settings.languageCode) {
                case "NL":
                case "NLD":
                case "DUT":
                    lang = 'nl';
                    break;
                default:
                    lang = 'en';
                    break;
            }
            window.SLSW.init({
                currency: {
                code: 'EUR',
                symbol: '€',
                decimalCount: '2',
                decimalSeparator: '.',
                thousandSeparator: ',',
                symbolPosition: 'BEGIN'
                },
                debug: true,
                language: lang,
                sound: {
                    enabledOnStartup: false,
                    initialVolume: 1,
                    volume: 0
                },
                feedsLink: this.feedsLink,
                historyLink: this.historyLink,
                gameWrapper: document.getElementById('gameContainer'),
                customSwButton: false,
                promotedFeature: this.promotedFeature,
                platform: this.platform,
                mode: this.api.gb.settings.playMode,
                // maxBet: 100,
                hitRate: this.hitRate/100,
            });

            window.SLSW.loadSounds();

            var btnElement = document.getElementById('superwheel-button');
            btnElement.appendChild(window.SLSW.getPresentationElements().swButton);
            btnElement.appendChild(this.getTotalBetDiv());

            var drag = new Draggable(document.getElementById('superwheel-button'));
            drag.dragElement();

            // sw-ui-rules-close
            btnElement = document.getElementById('sw-ui-rules-close');
            btnElement.onclick = () => {
                this.toggleHelp()
            };

            document.getElementById('superwheel-wrapper')
            .appendChild(window.SLSW.getPresentationElements().swWrapper);

            if(this._soundEnabled) {
                window.SLSW.setSoundVolume(1);
            } else {
                window.SLSW.setSoundVolume(0);
            }

            window.SLSW.onSwButtonStateChange((state) =>{
                if(state === 1) {
                    this.changeSwButtonState(true);
                    // this.raffles.push("https://sws.st01-lc-stakelogic.com/raffle/188199ce-9b94-4d2e-84d2-6fe166d97400");
                    // this.startNextRound();
                } else if (state === 0) {
                    this.changeSwButtonState(false);
                }
                this.sendState();

            });

            window.SLSW.onSoundStateChange((state) =>{
                if(state === 1) {
                    this._soundEnabled = true;
                } else if (state === 0) {
                    this._soundEnabled = false;
                }

            });

            window.SLSW.onRoundInit(() => {
                console.log("round init");
            });

            window.SLSW.onRoundCompleted((roundResults) => {
                // console.log("round results", roundResults);
                this.api.gb.emitters.emit.game.resumeGame();
                if(this._soundEnabled) {
                    this.api.gb.emitters.emit.game.soundOn();
                } else {
                    this.api.gb.emitters.emit.game.soundOff();
                }
                //TODO: update balance in game client
                this.startNextRound();
            });

        } catch (error) {
            console.log("error", error);
        }
    }

    changeSwButtonState(state) {
        if(state) {
            this.superwheelActive = true;
            this.roundsNotActive = 0;
            this.showTotalBet();
            if(!this._splashDisplayed)  {
                this._splashDisplayed = true;
                window.SLSW.showSplashPopup(() => {
                    console.log("splash popup closed");
                });
            }
        } else {
            this.hideTotalBet();
            this.superwheelActive = false;
        }
    }

    disableWheel() {
        window.SLSW.disableSwButton();
    }

    enableWheel() {
        window.SLSW.enableSwButton();
    }

    deactivateWheel() {
        window.SLSW.deactivateSuperWheel();
    }

    activateWheel() {
        window.SLSW.activateSuperWheel();
    }

    showTeaser(force) {
        return window.SLSW.runTeaserIfAvailable(force);
    }

    notifyInactiveSpinCompleted() {
        window.SLSW.notifyInactiveSpinCompleted();
    }

    toggleHelp() {
        var elms = document.querySelectorAll("[id='sw-ui-rules']");
        var elements = document.querySelectorAll("[id='sw-ui-rules-cont']");
        for(var i = 0; i < elms.length; i++) {
            if(elms[i].className === "gb") {
                elements[i].appendChild(window.SLSW.getPresentationElements().rulesWrapper);
                if(this._helpOpen) {
                    this._helpOpen = false;
                    elms[i].style.display='none';
                } else {
                    this._helpOpen = true;
                    elms[i].style.display='block';
                }
            }
        }
    }

    getTotalBetDiv() {
        var container = document.createElement("div");
        container.id = "sw-feat-btn-title";
        container.innerHTML = '<div id="superwheel-totalbet">' + this.getTotalBet() + '</div>';
        container.className = "superwheel-totalbet";
        this.totalBetContainer = container;
        return container;
    }

    sendState() {
        this.api.comm.sendSocketMsg({
            "type": "playerAction",
            "module": "stakelogic_superwheel",
            "instance": "superwheel",
            "action": "enabled",
            "data": {
                "state": this.superwheelActive
            }
        });
    }

    /**
     * Send periodic button state messages to agg front every 5 min
     */
    startKeepAlive() {
        setInterval(() => {
            this.sendState();
        }, 300000)
        ;
    }

    getTotalBet() {
        if(this.sideBetCalculationType === 'PERCENTAGE') {
            this.superWheelBet = this.api.gb.betAmount * this.sideBetAmount / 100;
            this.totalBet = this.superWheelBet + this.api.gb.betAmount;
        } else if (this.sideBetCalculationType === 'ABSOLUTE') {
            this.superWheelBet = this.sideBetAmount;
            this.totalBet = this.superWheelBet + this.api.gb.betAmount;
        }
        
        var totalBetText = '';
        switch(this.api.gb.settings.languageCode) {
            case "NL":
            case "NLD":
            case "DUT":
                totalBetText = "TOTALE INZET";
                break;
            case "HR":
                totalBetText = "UKUPNI KLAD";
                break;
            case "CZ":
                totalBetText = "CELKOVÁ SÁZKA";
                break;
            default:
                totalBetText = "TOTAL BET";
        }
        return 'SUPER WHEEL™ ' + (this.superWheelBet/100).toFixed(2) + ' € <br />' + totalBetText + ' ' + (this.totalBet/100).toFixed(2) + ' €';
    }

    updateTotalBet() {
        if(this.initialLoadReceived) {
            document.getElementById('superwheel-totalbet').innerHTML = this.getTotalBet();
        }
        
    }

    showTotalBet() {
        if(this.totalBetContainer) {
            this.totalBetContainer.style.display = "block";
        }
    }

    hideTotalBet() {
        if(this.totalBetContainer) {
            this.totalBetContainer.style.display = "none";
        }
    }

    soundOn() {
        this._soundEnabled = true;
        if(this.inited) {
            window.SLSW.setSoundVolume(1);
        }
    }

    soundOff() {
        this._soundEnabled = false;
        if(this.inited) {
            window.SLSW.setSoundVolume(0);
        }
    }

    setPlatform(platform) {
        switch (platform) {
            case "MOBILE":
                this.platform = 'MOBILE';
                break;
            default:
                this.platform = 'DESKTOP';
                break;
        }
    }

    updateBalance() {
        if (this.superwheelActive) {
            this.api.gb.emitters.emit.game.updateBalance({ balance: (this.api.gb.balance - this.superWheelBet), important: true, temp: true});
        }
    }
}